import { Component, Element, h, JSX, Prop, Host } from '@stencil/core';

const clamp = (value: number, min: number, max: number): number => Math.max(min, Math.min(value, max));

@Component({
  tag: 'rcm-column',
  styleUrl: 'rcm-column.scss',
  shadow: false,
})
export class RcmColumn {
  /** Offset of the columns (from 0 to 11) */
  @Prop() public offset = 0;

  /** Length of the column (from 1 to 12) */
  @Prop() public span: number;

  /** Length of the column from medium breakpoint up (from 1 to 12) */
  @Prop() public spanMedium: number;

  /** Length of the column from large breakpoint up (from 1 to 12) */
  @Prop() public spanLarge: number;

  /** Length of the column from x-large breakpoint up (from 1 to 12) */
  @Prop() public spanXlarge: number;

  /** Value of the gap property between columns */
  @Prop() public columnGap: string;

  /** Should the column be hidden on mobile screens */
  @Prop() public hiddenMobile: boolean;

  /** Should the column be hidden on mobile screens */
  @Prop() public hiddenMedium: boolean;

  /** Should the column be hidden on mobile screens */
  @Prop() public hiddenLarge: boolean;

  @Element() private element: HTMLRcmColumnElement;

  public componentWillRender(): void {
    const span = clamp(this.span, 1, 12);
    const offset = clamp(this.offset, 0, 11);
    const containerClasses = {
      column: true,
      [`is-${span}`]: !!this.span,
      [`is-offset-${offset}`]: !!this.offset,
      [`is-${this.spanMedium}-tablet`]: !!this.spanMedium,
      [`is-${this.spanLarge}-desktop`]: !!this.spanLarge,
      [`is-${this.spanXlarge}-widescreen`]: !!this.spanXlarge,
      'is-hidden-mobile': !!this.hiddenMobile,
      'is-hidden-tablett': !!this.hiddenMedium,
      'is-hidden-desktop': !!this.hiddenLarge,
    };

    // This is only needed due to the grid-system using Bulma under-the-hood
    Object.keys(containerClasses).forEach((item) => {
      this.element.classList[containerClasses[item] ? 'add' : 'remove'](item);
    });

    if (this.columnGap) {
      this.element.style.setProperty('--columnGap', this.columnGap);
    }
  }

  public render(): JSX.Element {
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
